(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-flippable"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.card-flippable').forEach(card => {
  card.querySelectorAll('.card-flippable-button').forEach(btn => {
    btn.addEventListener('click', () => {
      card.classList.toggle('flipped');
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
